import { mapGetters } from 'vuex'

export default {
  name: 'ToastRoot',
  computed: {
    ...mapGetters({
      toasts: 'toast/getToasts'
    })
  },
  methods: {
    destroyToast(id) {
      this.$store.commit('toast/destroyToast', id)
    }
  },
  components: {
    Toast: () => import('./Toast.vue')
  }
}
